import React, { useState, PropsWithChildren } from 'react';
import LineupManager from 'models/setLineup/LineupManager';
import { IProps as ITabContentProps } from './TabContent';
import { Tab } from './Tab';
import { TabListWrapper, TabWrapper } from './TabListStyles';

export interface IProps {
  onActiveTabChanged?: (activeTabName: string) => void;
  children: React.ReactElement<PropsWithChildren<ITabContentProps>>[];
  classNames?: string[];
  lineupManager?: LineupManager;
}
export const TabList: React.FC<PropsWithChildren<IProps>> = (props: PropsWithChildren<IProps>) => {
  const { onActiveTabChanged, children, classNames, lineupManager } = props;
  const [activeTab, setActiveTab] = useState<string>(children[0].props.name);
  const onClickTabItem = (name: string) => {
    if (onActiveTabChanged) {
      onActiveTabChanged(name);
    }
    setActiveTab(name);
  };

  return (
    <TabListWrapper className={`${classNames && classNames.join(' ')}`}>
      {!lineupManager?.isAddDesignatedHitterVisible && (
        <ul>
          {React.Children.map(children, (child: React.ReactElement<PropsWithChildren<ITabContentProps>>) => {
            const { label, name } = child.props;
            return <Tab isActive={activeTab === name} name={name} label={label} onClick={onClickTabItem} />;
          })}
        </ul>
      )}
      {lineupManager?.isAddDesignatedHitterVisible && (
        <TabWrapper>
          <ul>
            {React.Children.map(children, (child: React.ReactElement<PropsWithChildren<ITabContentProps>>) => {
              const { label, name } = child.props;
              return <Tab isActive={activeTab === name} name={name} label={label} onClick={onClickTabItem} />;
            })}
          </ul>
        </TabWrapper>
      )}
      <div className='tab-content'>
        {React.Children.map(children, (child: React.ReactElement<PropsWithChildren<ITabContentProps>>) => {
          if (child.props.name !== activeTab) return undefined;
          return child.props.children;
        })}
      </div>
    </TabListWrapper>
  );
};
